import type { ReactNode } from 'react';
import { IRowProps } from '../grid/Row';
import { DetailedPatreonPlug } from '../patreon/detailedPatreonPlug';
import { TPremiumCheckoutSurface } from './premiumXsollaAnalytics';

export type TPremiumRailSlotProps = {
  checkoutSurface?: TPremiumCheckoutSurface;
  showCheckoutFooter?: boolean;
  className?: string;
  rowProps?: IRowProps;
};

export type TPremiumRailRenderer = (props: TPremiumRailSlotProps) => ReactNode;

let premiumRailRenderer: TPremiumRailRenderer | null = null;

/**
 * Games register their purchase rail once at boot. Shared surfaces cannot import a
 * game's rail directly, and without this they would hardcode the Patreon plug and
 * offer a different provider than the Premium page does to the same buyer.
 */
export function setPremiumRailRenderer(renderer: TPremiumRailRenderer | null) {
  premiumRailRenderer = renderer;
}

export function getPremiumRailRenderer(): TPremiumRailRenderer | null {
  return premiumRailRenderer;
}

/** Falls back to the Patreon plug for games that never register a rail. */
export function PremiumRailSlot(props: TPremiumRailSlotProps) {
  const renderer = getPremiumRailRenderer();
  if (renderer) {
    return <>{renderer(props)}</>;
  }

  return (
    <DetailedPatreonPlug
      className={props.className}
      rowProps={props.rowProps}
      analyticsSurface={props.checkoutSurface}
    />
  );
}
